import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  PERIODOS_DASHBOARD,
  PeriodoDashboard,
  RangoPeriodo,
  fechaATexto,
  obtenerRangoPeriodo,
  textoAFecha,
} from "src/app/dashboard/shared/dashboard-graficas";

/**
 * Barra de periodo de una pestaña del Dashboard de Inicio: preset,
 * inicio y fin. No consulta nada: avisa el rango con `cambio` cada vez
 * que el usuario lo mueve y la pestaña decide que hacer. El rango inicial
 * lo calcula la pestaña con obtenerRangoPeriodo(periodoInicial), asi la
 * barra no emite durante su ngOnInit.
 *
 * Lo que la pestaña quiera mostrar a la derecha (total y etiqueta) lo
 * proyecta con un elemento marcado `meta`:
 *   <app-periodo-dashboard (cambio)="onPeriodo($event)">
 *     <div meta class="tickets-toolbar__meta"><span>N cosas</span><strong>{{ etiqueta }}</strong></div>
 *   </app-periodo-dashboard>
 */
@Component({
  selector: "app-periodo-dashboard",
  standalone: true,
  templateUrl: "./periodo-dashboard.component.html",
  styleUrls: ["../dashboard-tarjetas.css"],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIcon,
    MatInputModule,
    MatNativeDateModule,
  ],
})
export class PeriodoDashboardComponent implements OnInit {
  /** Presets disponibles; una pestaña puede recortarlos (p. ej. sin "Historico"). */
  @Input() periodos: PeriodoDashboard[] = PERIODOS_DASHBOARD;
  @Input() periodoInicial = "30";
  /** Prefijo de los id de los campos, para que dos barras en la misma pagina no choquen. */
  @Input() prefijo = "periodo";
  @Output() cambio = new EventEmitter<RangoPeriodo>();

  periodoSeleccionado = "30";
  fechaInicioSeleccionada: Date | null = null;
  fechaFinSeleccionada: Date | null = null;

  private inicio = "";
  private fin = "";

  ngOnInit() {
    this.periodoSeleccionado = this.periodoInicial;
    this.aplicarPeriodo(false);
  }

  /** Nombre del preset elegido, para la etiqueta de la pestaña. */
  get etiqueta(): string {
    return this.periodos.find((periodo) => periodo.id === this.periodoSeleccionado)?.nombre || "Periodo";
  }

  aplicarPeriodo(avisar = true): void {
    const rango = obtenerRangoPeriodo(this.periodoSeleccionado);
    this.inicio = rango.inicio;
    this.fin = rango.fin;
    this.fechaInicioSeleccionada = textoAFecha(rango.inicio);
    this.fechaFinSeleccionada = textoAFecha(rango.fin);
    if (avisar) {
      this.emitir();
    }
  }

  onFechaInicioChange(fecha: Date | null): void {
    this.inicio = fechaATexto(fecha);
    this.emitir();
  }

  onFechaFinChange(fecha: Date | null): void {
    this.fin = fechaATexto(fecha);
    this.emitir();
  }

  private emitir(): void {
    this.cambio.emit({ inicio: this.inicio, fin: this.fin });
  }
}
